import styled from "@emotion/styled";
import bg from "src/ui/assets/images/lyra_popup_bg.webp";
import lyraLogo from "src/ui/assets/partners/lyra-logo.svg";
import nineAmLogo from "src/ui/assets/icons/9am-logo-wordmark.svg";
import { CustomDialog } from "molecule/customDialog/CustomDialog";

/**
 * The custom background image requires some calculation.
 * The original width of the popup was 342px.
 * The original dimensions of the bg image are: 342px x 176px.
 * The cutout circle radius was 1462px;
 * The highest point of the cutout was at 143px;
 * https://www.figma.com/design/kUt51hgo6pKLtwoKEkih6M/%E2%9C%94-App?node-id=13094-80482&m=dev
 */
const ConnectLyraPopup = styled(CustomDialog)`
  label: ConnectLyraStyledPopupDialog;
  overflow: hidden;
  position: relative;
  min-height: calc((var(--popup-dialog-width) / 342) * 176);
  background: transparent;
  &:before {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    background-image: url("${bg}");
    background-position: 0 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: var(--popup-dialog-width);
    aspect-ratio: 342 / 176;
    z-index: -2;
  }
  &:after {
    position: absolute;
    top: calc((var(--popup-dialog-width) / 342) * 143);
    left: calc(var(--popup-dialog-width) * ((-731 + 171) / 342));
    width: calc((var(--popup-dialog-width) / 342) * 1462);
    aspect-ratio: 1;
    content: "";
    background-color: var(--color-white, #ffffff);
    background-position: 0 0;
    border-radius: 50%;
    z-index: -1;
  }
`;

const LyraHeader = styled.div`
  label: StyledLyraPopupHeader;
  height: calc((var(--popup-dialog-width) / 342) * 176);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.125rem /* 18/16 */;
  padding-bottom: 2.0625rem /* 33/16 */;
`;

const LyraLogo = styled.div`
  label: LyraLogo;
  flex: 0 0 4.75rem /* 76/16 */;
  height: 100%;
  background-image: url("${lyraLogo}");
  background-position: center;
  background-repeat: no-repeat;
`;

const Separator = styled.div`
  label: LyraSeparator;
  flex: 0 0 0.1875rem /* 3/16 */;
  height: 4.5625rem /* 73/16 */;
  background-color: var(--color-white, #ffffff);
`;

const NineAmLogo = styled.div`
  label: Lyra9amLogo;
  flex: 0 0 5rem /* 80/16 */;
  height: 100%;
  background-image: url("${nineAmLogo}");
  background-position: center;
  background-repeat: no-repeat;
`;

const Wrapper = styled.div`
  label: LyraWrapper;
  display: flex;
  flex-flow: column nowrap;
  text-align: center;
  justify-content: center;
  padding: 0 1.5rem /* 24/16 */ 1.5rem /* 24/16 */ 1.5rem /* 24/16 */;
`;

const Description = styled.div`
  label: LyraPopupDescription;
  margin-bottom: 1.5rem /* 24/16 */;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Body/Body1 */
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  letter-spacing: -0.02rem /* -0.32/16 */;
`;

const Action = styled.div`
  label: LyraPopupAction;
  display: flex;
  flex-flow: column nowrap;
  gap: 0.75rem /* 12/16 */;
`;

export const BehavioralPopupConnectLyraStyled = {
  ConnectLyraPopup,
  LyraHeader,
  LyraLogo,
  Separator,
  NineAmLogo,
  Wrapper,
  Description,
  Action
};
